import React from 'react';
import { TipTypeSelectionConnected } from '../TipTypeSelection/TipTypeSelection';
import { TipTypeOptions } from '../TipTypeSelection/TipTypeSelection';
import { CurrencyCode } from '../../PaymentGateway/interfaces/currencies';
import { PricingTier } from '../../PaymentGateway/utils/pricingTier';
import { Tip } from '../interfaces/tip/Tip';
import { valueof } from '../interfaces/tip/MatchForecast';
import { SimpleTip } from '../interfaces/tip/SimpleTip';
import { CombinedTip } from '../interfaces/tip/CombinedTip';

interface StepThreeProps {
  hooks: {
    tip: SimpleTip | CombinedTip;
    handleTipValue: (key: keyof Tip, value: valueof<Tip>) => void;
  };
  pricingTiers: PricingTier[];
  showValidations: boolean;
  currency: CurrencyCode;
}

export const StepThree: React.FC<StepThreeProps> = ({
  hooks: { tip, handleTipValue },
  pricingTiers,
  showValidations,
  currency,
}) => {
  return (
    <>
      <TipTypeSelectionConnected
        currency={currency}
        hooks={{ tip, handleTipValue }}
        pricingTiers={pricingTiers}
        tipValues={{
          priceType: tip.priceType,
          pricingTierCode: tip.pricingTierCode,
        }}
        onSelect={(tipTypeOptions: TipTypeOptions) => {
          handleTipValue('priceType', tipTypeOptions.type);
        }}
      />
    </>
  );
};
